import { render, staticRenderFns } from "./file-view.vue?vue&type=template&id=60567e9d&scoped=true&"
import script from "./file-view.vue?vue&type=script&lang=js&"
export * from "./file-view.vue?vue&type=script&lang=js&"
import style0 from "./file-view.vue?vue&type=style&index=0&id=60567e9d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60567e9d",
  null
  
)

export default component.exports